import { render, staticRenderFns } from "./NewAIBuilder.vue?vue&type=template&id=0bb448f6&"
import script from "./NewAIBuilder.vue?vue&type=script&lang=ts&"
export * from "./NewAIBuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports